<!-- <div class="container-fluid"> -->
  <mat-card>
    <mat-card-content>
      <form [formGroup]="emSignerForm">
        <mat-accordion>
          <mat-expansion-panel expanded hideToggle >
            <mat-expansion-panel-header>
              <mat-panel-title>
                Em-Signer Configuration
              </mat-panel-title>
            </mat-expansion-panel-header>
            
            <div class="flex-wrap d-flex p-0">
              <div class="col-md-4">
                <div class="dense-2">
                  <mat-form-field appearance="outline">
                    <mat-label>Secret Key / License Key</mat-label>
                    <input 
                      [type]="hideSecretKey ? 'password' : 'text'"
                      matInput 
                      autocomplete="off" 
                      formControlName="secretKey"
                      [errorStateMatcher]="matcher">
                    <button 
                      mat-icon-button 
                      matSuffix 
                      (click)="toggleSecretKeyVisibility()" 
                      [attr.aria-label]="'Hide Secret Key'" 
                      [attr.aria-pressed]="hideSecretKey"
                      type="button">
                      <mat-icon>{{hideSecretKey ? 'visibility_off' : 'visibility'}}</mat-icon>
                    </button>
                    <mat-error *ngIf="emSignerForm.get('secretKey').hasError('required')">
                      Secret Key is required
                    </mat-error>
                  </mat-form-field>
                </div>
              </div>

              <div class="col-md-4">
                <div class="dense-2">
                  <mat-form-field appearance="outline">
                    <mat-label>App Name</mat-label>
                    <input 
                      type="text" 
                      matInput 
                      autocomplete="off" 
                      formControlName="appName"
                      [errorStateMatcher]="matcher">
                    <mat-error *ngIf="emSignerForm.get('appName').hasError('required')">
                      App Name is required
                    </mat-error>
                  </mat-form-field>
                </div>
              </div>

              <div class="col-md-4">
                <div class="dense-2">
                  <mat-form-field appearance="outline">
                    <mat-label>Username</mat-label>
                    <input 
                      type="text" 
                      matInput 
                      autocomplete="off" 
                      formControlName="username"
                      [errorStateMatcher]="matcher">
                    <mat-error *ngIf="emSignerForm.get('username').hasError('required')">
                      Username is required
                    </mat-error>
                  </mat-form-field>
                </div>
              </div>

              <div class="col-md-4">
                <div class="dense-2">
                  <mat-form-field appearance="outline">
                    <mat-label>Password</mat-label>
                    <input 
                      [type]="hidePassword ? 'password' : 'text'"
                      matInput 
                      autocomplete="off" 
                      formControlName="password"
                      [errorStateMatcher]="matcher">
                    <button 
                      mat-icon-button 
                      matSuffix 
                      (click)="togglePasswordVisibility()" 
                      [attr.aria-label]="'Hide Password'" 
                      [attr.aria-pressed]="hidePassword"
                      type="button">
                      <mat-icon>{{hidePassword ? 'visibility_off' : 'visibility'}}</mat-icon>
                    </button>
                    <mat-error *ngIf="emSignerForm.get('password').hasError('required')">
                      Password is required
                    </mat-error>
                  </mat-form-field>
                </div>
              </div>
            </div>

            <div class="d-flex col-md-12 p-0 justify-content-end">
              <button 
                color="primary" 
                class="outlined-btn" 
                mat-raised-button 
                (click)="resetForm()" 
                type="reset" 
                [disabled]="isLoading">
                Reset
              </button>
              <button 
                mat-raised-button 
                color="accent" 
                class="ml-3" 
                (click)="onSubmit()"
                [disabled]="!emSignerForm.valid || isLoading || !hasChanges">
                Save Configuration
              </button>
            </div>
          </mat-expansion-panel>
        </mat-accordion>
      </form>
    </mat-card-content>
  </mat-card>
<!-- </div> -->
